import { createVfm, useVfm } from 'vue-final-modal'

declare module '#app' {
  type NuxtApp = {
    $useVfm: typeof useVfm
  }
}

declare module 'vue' {
  type ComponentCustomProperties = {
    $useVfm: typeof useVfm
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const vfm = createVfm()
  nuxtApp.vueApp.use(vfm)

  return {
    provide: {
      useVfm,
    },
  }
})
